export default {
  install (Vue, options) {
    const $metatag = {
      formateMeta (e) {
        let metatag = {}

        if (e.html_head) {
          for (let entry of e.html_head) {
            let tag = entry[0]['#tag']
            let attributes = entry[0]['#attributes']

            if (tag === 'meta') {
              if (attributes.name === 'title') {
                metatag.title = attributes.content
              } else {
                addEntry({vmid: attributes.name, name: attributes.name, content: attributes.content}, 'meta')
              }
            }

            if (tag === 'link') {
              addEntry({rel: attributes.rel, href: fixeUrl(attributes.href)}, 'link')
            }
          }
        }

        function addEntry (e, t) {
          if (metatag[t]) {
            metatag[t].push(e)
          } else {
            metatag[t] = [e]
          }
        }

        function fixeUrl (u) {
          return u.replace(/backend\//g, '')
        }

        return metatag
      }
    }

    Vue.prototype.$metatag = $metatag
    Vue.$metatag = $metatag
  }
}
